'use client'
const validatePassword = (password) => {
    const hasProperLength = password.length >= 6;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /\d/.test(password);
    const hasNonalphas = /\W/.test(password);
    let strength = [
        hasLowerCase,
        hasUpperCase,
        hasNumbers,
        hasNonalphas,
        hasProperLength,
    ].filter(Boolean).length;
    if (strength >= 3 && password.length >= 12) {
        strength = 5;
    }
    const securityCriteria = [
        {
            description: 'Password is atleast 6 characters in length',
            key: 'hasProperLength',
            value: hasProperLength,
        },
        {
            description: 'Contains at least one uppercase letter',
            key: 'hasUpperCase',
            value: hasUpperCase,
        },
        {
            description: 'Contains at least one lowercase letter',
            key: 'hasLowerCase',
            value: hasLowerCase,
        },
        {
            description: 'Contains at least one number',
            key: 'hasNumbers',
            value: hasNumbers,
        },
        {
            description: 'Contains at least one non-alphanumeric character',
            key: 'hasNonalphas',
            value: hasNonalphas,
        },
    ];
    return {
        hasLowerCase,
        hasNonalphas,
        hasNumbers,
        hasProperLength,
        hasUpperCase,
        securityCriteria,
        strength,
    };
};

export { validatePassword };
